import './LoginApp.less';
import React, {useContext} from 'react';
import BeforeLoginTemplate from "../../templates/before-login/BeforeLoginTemplate";
import __ from "../../i18n";
import routes from "../../routing/routes";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../bootstrap/api/Request";
import AuthLoginParcel from "../../api/endpoints/auth/AuthLoginParcel";
import {createEmailRegex} from "../../../bootstrap/regex/common";
import {Link, useHistory} from "react-router-dom";
import AuthContext from "../../contexts/auth/AuthContext";
import HistoryContext from "../../contexts/history/HistoryContext";


export default function LoginApp() {

    const history = useHistory();

    const authContext = useContext(AuthContext);

    const historyContext = useContext(HistoryContext);

    const getFieldsConfig = () => {
        return {
            email: {
                type: 'text',
                name: __('Email'),
                rules: {
                    required: true,
                },
                options: {
                    appearance: 'box',
                    placeholder: __('email@example.com')
                }
            },
            password: {
                type: 'text',
                name: __('Password'),
                rules: {
                    required: true
                },
                options: {
                    style: 'password',
                    passwordCanShow: true,
                    appearance: 'box',
                    placeholder: __('Enter your password')
                }
            }
        };
    };

    const getLayoutConfig = () => {
        return [
            'email',
            'password',
        ];
    };

    const handleSubmit = (values, onSuccess, onError) => {
        if (!createEmailRegex().test(values.email)) {
            onError(__('Invalid email'));
            return;
        }

        Request.add(new AuthLoginParcel(values.email, values.password))
            .then(info => {
                authContext.setInfo(info);

                if (historyContext.loginReferer !== null) {
                    history.push(historyContext.loginReferer);
                } else {
                    history.push(routes.home.getUrl());
                }
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    return <div className="login-app">
        <BeforeLoginTemplate>
            <div className="app-title">{__('Login')}</div>
            <div className="register-ask">
                <span>{__('Do not have an account?')}</span>
                <Link className="text-link" to={routes.register.getUrl()}>{__('Sign up here')}</Link>
            </div>
            <CustomForm
                fieldsConfig={getFieldsConfig()}
                layoutConfig={getLayoutConfig()}
                submit={handleSubmit}
                submitText={__('Login')}
                allowsSubmit={(hasChanges, values, errors) => Object.keys(errors).length === 0}
                actionsTemplate={[
                    ['submitButton'],
                    [
                        <div
                            key="forgot-password"
                            className="forgot-password"
                        >
                            <Link
                                className="text-link"
                                to={routes.forgot_password.getUrl()}
                            >
                                {__('Forgot password?')}
                            </Link>
                        </div>
                    ]
                ]}
            />
        </BeforeLoginTemplate>
    </div>;
}
